import axios from 'axios';
import fnc from '../../mymod/commFunction';
import { store2 } from '../../store';
import { addDays } from '../utils/dateUtils';

export const getSchedulerContext = () => {
  const loginState = store2.getState()?.reduxStore || {};
  const primaryUser = loginState.userInfo || {};
  const socialUser = loginState.userInfo2 || {};

  return {
    acaCode: fnc.getCookie('acaCode') || primaryUser.acaCode || socialUser.acaCode || '',
    stCode: primaryUser.stCode || socialUser.stCode || fnc.getCookie('stCode') || '',
    db: fnc.getCookie('acaDbName') || primaryUser.acaDbName || socialUser.acaDbName || '',
    studentName: primaryUser.name || socialUser.name || socialUser.nickname || fnc.getCookie('userName') || '',
    userRole: fnc.getCookie('userRole') || (primaryUser.stCode ? 'student' : ''),
  };
};

export const hasSchedulerContext = () => {
  const { acaCode, stCode, db, userRole } = getSchedulerContext();
  return userRole !== 'parent' && Boolean(acaCode && stCode && db);
};

const request = async (url, data = {}) => {
  const context = getSchedulerContext();
  if (!context.acaCode || !context.stCode || !context.db) {
    return {
      code: 'AUTH_REQUIRED',
      error: '학생 로그인이 필요합니다. 로그인 후 다시 이용해 주세요.',
    };
  }

  try {
    const { acaCode, stCode, db } = context;
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER_URL}${url}`,
      { acaCode, stCode, db, ...data },
    );
    return response.data;
  } catch (error) {
    return error.response?.data || { error: '서버와 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.' };
  }
};

export const fetchDailySchedules = (studyDate) => request('/scheduler/list', { studyDate });

export const fetchDailyReport = (studyDate) => request('/scheduler/daily-report', { studyDate });

export const createSchedule = (schedule) => request('/scheduler/insert', schedule);

export const updateSchedule = (schedule) => request('/scheduler/update', schedule);

export const updateScheduleStatus = (sno, status) => request('/scheduler/status', { sno, status });

export const deleteSchedule = (sno) => request('/scheduler/delete', { sno });

export const submitDailySchedule = (studyDate) => request('/scheduler/submit-day', { studyDate });

export const fetchUpcomingExams = () => request('/scheduler/exams/list');

export const createExam = (exam) => request('/scheduler/exams/insert', exam);

export const updateExam = (exam) => request('/scheduler/exams/update', exam);

export const deleteExam = (sno) => request('/scheduler/exams/delete', { sno });

export const fetchRecentLearningHistory = async (studyDate, days = 7) => {
  const safeDays = Math.min(14, Math.max(1, Number(days) || 7));
  const dateKeys = Array.from(
    { length: safeDays },
    (_, index) => addDays(studyDate, index - (safeDays - 1)),
  );
  const responses = await Promise.all(
    dateKeys.map(async (dateKey) => ({
      dateKey,
      response: await request('/scheduler/list', { studyDate: dateKey }),
    })),
  );

  return {
    plans: responses.flatMap(({ dateKey, response }) => (
      Array.isArray(response)
        ? response.map((plan) => ({ ...plan, studyDate: plan.studyDate || dateKey }))
        : []
    )),
    requestedDays: dateKeys,
    failedDays: responses.filter(({ response }) => response?.error).map(({ dateKey }) => dateKey),
  };
};
